import { useEffect, useState } from 'react';
import { apiCall, default as API_CONFIG } from '../config/api';

/**
 * Single-doc fetch from `/api/transcripts/{id}` -- returns the full
 * Transcript shape including chunks + per-chunk summaries + raw text.
 *
 * No cache here; the detail view should always show fresh data because
 * orchestration finishes asynchronously and the fields populate over
 * ~30-90s after upload. Cheap point read on `/id` partition.
 */
export const useTranscript = (id) => {
  const [transcript, setTranscript] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) {
      setTranscript(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);

    apiCall(API_CONFIG.endpoints.transcriptById(id))
      .then((data) => {
        if (cancelled) return;
        setTranscript(data);
      })
      .catch((err) => {
        if (cancelled) return;
        console.error('Failed to load transcript', id, err);
        // Distinguish 404 from other errors so the UI can show "not found"
        // rather than "load failed".
        const msg = (err?.message || '').toLowerCase();
        if (msg.includes('not found') || msg.includes('404')) {
          setError('not-found');
        } else {
          setError('Failed to load transcript');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [id]);

  return { transcript, loading, error };
};
